module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/10SqJQc/Images/cover.jpg?1739571219919",
      "alt": "This image is the cover for the book Scandalous Marriage"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Scandalous Marriage\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Marriage under fire")]), _c('br'), _c('br'), _vm._v("William and June Pemberton have been happily married for three yearsbut the longer they go on without June’s conceiving, the more concerned she becomes. Especially since William’s old flame is now free to marry again and, according to his mother, would make him much the better wife. And then a handsome charmer turns his attentions to June."), _c('br'), _c('br'), _vm._v("Pushed apart by jealousy, William and June must fight to keep their marriage alive. Sometimes, it seems, their mutual passion is all that holds them together.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mary Brendan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Mary Brendan was always a keen reader of historical romance,  especially the Regency period. She also writes gritty sagas under a different pseudonym.  She was born in north London, lived for a while in Suffolk, and is now back closer to her roots and her adult sons in a village in Hertfordshire. When time permits, she relaxes by browsing junk shops, or by researching family history.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0